// Get the correct logo source for both file paths and base64 strings
export const getLogoSrc = (logoUrl, apiBaseUrl) => {
  if (!logoUrl) return null;

  // If it's already a base64 string (starts with 'data:'), use it directly
  if (logoUrl.startsWith('data:')) {
    return logoUrl;
  }

  // Otherwise it's a file path, prepend API_BASE_URL
  return `${apiBaseUrl}${logoUrl}`;
};
